import { FC, memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Tooltip } from "@fluentui/react-components";
import { Settings24Regular } from "@fluentui/react-icons";
import { CompanyPickerDialog } from "@/components/CompanyPickerDialog/CompanyPickerDialog";
import styles from "@/components/CompanySwitcher/CompanySwitcher.module.css";
import type { CompanySwitcherProps } from "@/components/CompanySwitcher/CompanySwitcher.types";

export const CompanySwitcher: FC<CompanySwitcherProps> = memo(
  ({ companies, currentCompanyKey, onSwitch }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);

    return (
      <>
        <div className={styles.cog}>
          <Tooltip content={t("Switch platform")} relationship="label">
            <Button
              appearance="primary"
              shape="circular"
              size="large"
              icon={<Settings24Regular />}
              className={styles.button}
              onClick={() => setOpen(true)}
            />
          </Tooltip>
        </div>
        {open && (
          <CompanyPickerDialog
            companies={companies}
            currentCompanyKey={currentCompanyKey}
            onClose={close}
            onValidate={(company) => {
              onSwitch(company);
              close();
            }}
          />
        )}
      </>
    );
  },
);
